var map = {
	"./24-support.svg": "6518",
	"./3d-cube-scan.svg": "b1fd",
	"./3d-rotate.svg": "4a11",
	"./3d-square.svg": "38c9",
	"./3dcube.svg": "a51f",
	"./3square.svg": "68a3",
	"./F22.svg": "1899",
	"./F29.svg": "c8dd",
	"./WebPay.svg": "c16f",
	"./activity.svg": "8dd6",
	"./add-circle.svg": "8729",
	"./add-square.svg": "e386",
	"./add.svg": "76a4",
	"./additem.svg": "c1f0",
	"./airdrop.svg": "3aa1",
	"./airplane-square.svg": "071e",
	"./airplane.svg": "24be",
	"./airpod.svg": "52b5",
	"./airpods.svg": "2c0f",
	"./alarm.svg": "c3bd",
	"./align-bottom.svg": "75db",
	"./align-horizontally.svg": "0c86",
	"./align-left.svg": "d4aa",
	"./align-right.svg": "7526",
	"./align-vertically.svg": "97ce",
	"./aquarius.svg": "d613",
	"./archive-1.svg": "cbdf",
	"./archive-add.svg": "5c76",
	"./archive-book.svg": "abf4",
	"./archive-minus.svg": "e02b",
	"./archive-slash.svg": "ceb4",
	"./archive-tick.svg": "14dc",
	"./archive.svg": "8238",
	"./arrange-circle-2.svg": "3b24",
	"./arrange-circle.svg": "6269",
	"./arrange-square-2.svg": "ab2d",
	"./arrange-square.svg": "01e2",
	"./arrow-2.svg": "f82a",
	"./arrow-3.svg": "1304",
	"./arrow-bottom.svg": "ae00",
	"./arrow-circle-down.svg": "e132",
	"./arrow-circle-left.svg": "6d65",
	"./arrow-circle-right.svg": "a787",
	"./arrow-down-1.svg": "f595",
	"./arrow-down-2.svg": "8587",
	"./arrow-down.svg": "c874",
	"./arrow-left-1.svg": "c865",
	"./arrow-left-2.svg": "5ada",
	"./arrow-left-3.svg": "06e4",
	"./arrow-left.svg": "ac3b",
	"./arrow-right-1.svg": "070d",
	"./arrow-right-2.svg": "ba21",
	"./arrow-right-3.svg": "a830",
	"./arrow-right.svg": "cd8c",
	"./arrow-square-down.svg": "2e21",
	"./arrow-square-left.svg": "f661",
	"./arrow-square-right.svg": "dccb3",
	"./arrow-square-up.svg": "4914",
	"./arrow-square.svg": "9c82",
	"./arrow-swap-horizontal.svg": "cdd5",
	"./arrow-up-1.svg": "b97cf",
	"./arrow-up-2.svg": "86d7",
	"./arrow-up-3.svg": "74e6",
	"./arrow-up.svg": "a3f8",
	"./arrow.svg": "21e2",
	"./attach-circle.svg": "296f",
	"./attach-square.svg": "c358",
	"./audio-square.svg": "cff9",
	"./autobrightness.svg": "c78a",
	"./award.svg": "d815",
	"./back-square.svg": "f8ce",
	"./backward-10-seconds.svg": "00a8",
	"./backward-15-seconds.svg": "25a6",
	"./backward-5-seconds.svg": "f443",
	"./backward-item-1.svg": "f69b",
	"./backward-item.svg": "e994",
	"./backward.svg": "1412",
	"./bag-2.svg": "01b9",
	"./bag-cross-1.svg": "04c0",
	"./bag-cross.svg": "9048",
	"./bag-happy.svg": "ec0d",
	"./bag-tick-2.svg": "457a",
	"./bag-tick.svg": "dcfd",
	"./bag-timer.svg": "289a",
	"./bag.svg": "47fd",
	"./bank.svg": "02f2",
	"./barcode.svg": "b632",
	"./battery-3full.svg": "9e49",
	"./battery-charging.svg": "cc3c",
	"./battery-disable.svg": "6488",
	"./battery-empty-1.svg": "18ac",
	"./battery-empty.svg": "d139",
	"./battery-full.svg": "8bf9",
	"./bezier-1.svg": "92e4",
	"./bezier.svg": "7812",
	"./bill.svg": "5ac8",
	"./bitcoin-card.svg": "51ba",
	"./bitcoin-convert.svg": "294e",
	"./bitcoin-refresh.svg": "2897",
	"./blend-2.svg": "2d51",
	"./blend.svg": "30b6",
	"./bluetooth-2.svg": "25b3",
	"./bluetooth-circle.svg": "4cc7",
	"./bluetooth-rectangle.svg": "7068",
	"./bluetooth.svg": "1565",
	"./blur-1.svg": "2e0f",
	"./blur.svg": "6c44",
	"./book-1.svg": "80f1",
	"./book-saved.svg": "2da6",
	"./book-square.svg": "43e5",
	"./book.svg": "fc4e",
	"./bookmark-2.svg": "1c80",
	"./bookmark.svg": "7253",
	"./box-1.svg": "8ad5",
	"./box-2.svg": "659c",
	"./box-add.svg": "5aeb",
	"./box-remove.svg": "db75",
	"./box-search.svg": "3220",
	"./box-tick.svg": "4f33",
	"./box-time.svg": "3571",
	"./box.svg": "bb19",
	"./briefcase.svg": "24c9",
	"./brifecase-cross.svg": "018d",
	"./brifecase-tick.svg": "55b5",
	"./brifecase-timer.svg": "2b9a",
	"./broom.svg": "c792",
	"./brush-1.svg": "be69",
	"./brush-2.svg": "7139",
	"./brush-3.svg": "562b",
	"./brush.svg": "3f92",
	"./bubble.svg": "e526",
	"./bucket-circle-1.svg": "bec0",
	"./bucket-circle.svg": "5ce0",
	"./bucket-square-1.svg": "c5a9",
	"./bucket-square.svg": "fb92",
	"./building-3.svg": "8ced",
	"./building-4.svg": "55cc",
	"./building.svg": "a528",
	"./buildings-2.svg": "85a9",
	"./buildings.svg": "23f5",
	"./buliding.svg": "20fd",
	"./bus.svg": "c2d2",
	"./buy-crypto.svg": "cbc4",
	"./cake.svg": "c7cc",
	"./calculator.svg": "250e",
	"./calendar-1.svg": "6164",
	"./calendar-2.svg": "9a70",
	"./calendar-add.svg": "f193",
	"./calendar-circle.svg": "3007",
	"./calendar-edit.svg": "32a2",
	"./calendar-remove.svg": "6eeb",
	"./calendar-search.svg": "f135",
	"./calendar-tick.svg": "bb02",
	"./calendar.svg": "b8bd",
	"./call-add.svg": "2621",
	"./call-calling.svg": "e8f8",
	"./call-incoming.svg": "bebb",
	"./call-minus.svg": "d6cb",
	"./call-outgoing.svg": "76f1",
	"./call-received.svg": "337b",
	"./call-remove.svg": "d1f9",
	"./call-slash.svg": "971f",
	"./call.svg": "01f2",
	"./camera-slash.svg": "0f7f",
	"./camera.svg": "24e5",
	"./candle-2.svg": "14eb",
	"./candle.svg": "a61b",
	"./car.svg": "14cf",
	"./card-add.svg": "7454",
	"./card-coin.svg": "2bcc",
	"./card-edit.svg": "12b7",
	"./card-pos.svg": "0f7a",
	"./card-receive.svg": "c254",
	"./card-remove-1.svg": "232d",
	"./card-remove.svg": "32bf",
	"./card-send.svg": "5650",
	"./card-slash.svg": "734f",
	"./card-tick-1.svg": "4c9b",
	"./card-tick.svg": "ee17",
	"./card.svg": "5d4a",
	"./cards.svg": "3c00",
	"./category-2.svg": "b9b3",
	"./category.svg": "d0ab",
	"./cd.svg": "f3d6",
	"./chart-1.svg": "ddb2",
	"./chart-2.svg": "e042",
	"./chart-21.svg": "5f7f",
	"./chart-3.svg": "e414",
	"./chart-square.svg": "61e2",
	"./chart-success.svg": "87e1",
	"./chart.svg": "2f02",
	"./check.svg": "7bae",
	"./chrome.svg": "b5dd",
	"./clipboard-close.svg": "8e98",
	"./clipboard-export.svg": "8600",
	"./clipboard-import.svg": "1aa7",
	"./clipboard-text.svg": "d105",
	"./clipboard-tick.svg": "23e6",
	"./clipboard.svg": "4247",
	"./clock-1.svg": "41a2",
	"./clock.svg": "755b",
	"./close-circle.svg": "1cfc",
	"./close-square.svg": "3d02",
	"./cloud-add.svg": "f7b5",
	"./cloud-change.svg": "6b68",
	"./cloud-connection.svg": "ec77",
	"./cloud-cross.svg": "8c97",
	"./cloud-drizzle.svg": "59f4",
	"./cloud-fog.svg": "9fdd",
	"./cloud-lightning.svg": "79ac",
	"./cloud-minus.svg": "0557",
	"./cloud-notif.svg": "0217",
	"./cloud-plus.svg": "54ca",
	"./cloud-remove.svg": "6652",
	"./cloud-snow.svg": "13d6",
	"./cloud-sunny.svg": "a097",
	"./cloud.svg": "2b35",
	"./code-1.svg": "bf68",
	"./code-circle.svg": "ed73",
	"./code.svg": "100a",
	"./coffee.svg": "aa5e",
	"./coin-1.svg": "423f",
	"./coin.svg": "b0cb",
	"./color-swatch.svg": "68a8",
	"./colorfilter.svg": "3005",
	"./colors-square-1.svg": "63ea",
	"./colors-square.svg": "978c",
	"./command-square.svg": "6964",
	"./command.svg": "870e",
	"./component-1.svg": "e793",
	"./component.svg": "51c3",
	"./computing.svg": "19b1",
	"./convert-3d-cube.svg": "ca2b",
	"./convert.svg": "91aa",
	"./convertshape-2.svg": "b19c",
	"./convertshape.svg": "2bfbf",
	"./copy-success.svg": "906b",
	"./copy.svg": "8aac",
	"./copyright.svg": "945d",
	"./courthouse.svg": "11b7",
	"./cpu-charge.svg": "f5af",
	"./cpu-setting.svg": "9221",
	"./cpu.svg": "2769",
	"./creative-commons.svg": "322f",
	"./crop.svg": "2269",
	"./crown-1.svg": "5e28",
	"./crown.svg": "07b0",
	"./cup.svg": "5e13",
	"./danger.svg": "f6f2",
	"./data-2.svg": "356b",
	"./data.svg": "e756",
	"./default.svg": "b5c3",
	"./designtools.svg": "42e0",
	"./device-message.svg": "6ad9",
	"./devices-1.svg": "8d24",
	"./devices.svg": "0006",
	"./diagram.svg": "6045",
	"./diamonds.svg": "75c9",
	"./direct-down.svg": "c54c",
	"./direct-inbox.svg": "7299",
	"./direct-left.svg": "df35",
	"./direct-normal.svg": "e1da",
	"./direct-notification.svg": "7d49",
	"./direct-right.svg": "7c7c",
	"./direct-send.svg": "7d84",
	"./direct-up.svg": "1153",
	"./direct.svg": "6643",
	"./directbox-default.svg": "09da",
	"./directbox-notif.svg": "bcae",
	"./directbox-receive.svg": "2877e",
	"./directbox-send.svg": "f297",
	"./discount-circle.svg": "bab8",
	"./discount-shape.svg": "2a20",
	"./discover-1.svg": "9e3b",
	"./discover.svg": "b150",
	"./dislike.svg": "a2a2",
	"./document-1.svg": "6df1",
	"./document-cloud.svg": "ec33",
	"./document-code-2.svg": "6e8b",
	"./document-code.svg": "9f61",
	"./document-copy.svg": "5e0c",
	"./document-download.svg": "8902",
	"./document-favorite.svg": "7569",
	"./document-filter.svg": "6fad",
	"./document-forward.svg": "d90d",
	"./document-like.svg": "c8a9",
	"./document-normal.svg": "0c02",
	"./document-previous.svg": "ece4",
	"./document-sketch.svg": "cc42",
	"./document-text-1.svg": "f5d2",
	"./document-text.svg": "95bc",
	"./document-upload.svg": "1b26",
	"./document.svg": "4aa0",
	"./dollar-circle.svg": "ad13",
	"./dollar-square.svg": "3738",
	"./driver-2.svg": "2630",
	"./driver-refresh.svg": "a4a8",
	"./driver.svg": "345c",
	"./driving.svg": "f2ac",
	"./drop.svg": "c63c",
	"./edit-2.svg": "72c9",
	"./edit.svg": "daf0",
	"./electricity.svg": "62cb",
	"./element-1.svg": "03f5",
	"./element-2.svg": "83f5",
	"./element-3.svg": "e997",
	"./element-4.svg": "88ec",
	"./element-equal.svg": "c158",
	"./element-plus.svg": "31fc",
	"./emoji-happy.svg": "385c",
	"./emoji-normal.svg": "1d81",
	"./emoji-sad.svg": "c19a",
	"./empty-wallet-add.svg": "1d31",
	"./empty-wallet-change.svg": "e459",
	"./empty-wallet-remove.svg": "2794",
	"./empty-wallet-tick.svg": "b219",
	"./empty-wallet-time.svg": "7039",
	"./empty-wallet.svg": "f510",
	"./eraser-1.svg": "cc09",
	"./eraser-2.svg": "7d04",
	"./eraser.svg": "3b6f",
	"./export-1.svg": "635a",
	"./export-2.svg": "e3db",
	"./export-3.svg": "58bf3",
	"./export.svg": "1578",
	"./external-drive.svg": "4131",
	"./eye-slash.svg": "905f",
	"./eye.svg": "7364",
	"./fatrows.svg": "02bd",
	"./favorite-chart.svg": "69d8",
	"./filter-add.svg": "2e8a",
	"./filter-edit.svg": "3fb6",
	"./filter-remove.svg": "55fd",
	"./filter-search.svg": "3d26",
	"./filter-square.svg": "b309",
	"./filter-tick.svg": "c007",
	"./filter.svg": "2376",
	"./finger-cricle.svg": "d735",
	"./finger-scan.svg": "82ab",
	"./firstline.svg": "cf8c",
	"./flag-2.svg": "eaa8",
	"./flag.svg": "c26e",
	"./flash-1.svg": "cee1",
	"./flash-circle-1.svg": "06e0",
	"./flash-circle-2.svg": "3c6f",
	"./flash-circle.svg": "7a3f",
	"./flash-slash.svg": "cb64",
	"./flash.svg": "782a",
	"./folder-2.svg": "d12e",
	"./folder-add.svg": "251c",
	"./folder-cloud.svg": "b133",
	"./folder-connection.svg": "5990",
	"./folder-cross.svg": "b328",
	"./folder-favorite.svg": "c342",
	"./folder-minus.svg": "a509",
	"./folder-open.svg": "bc8c",
	"./folder.svg": "383d",
	"./format-circle.svg": "8ce8",
	"./format-square.svg": "26fb",
	"./forward-10-seconds.svg": "280e",
	"./forward-15-seconds.svg": "df72",
	"./forward-5-seconds.svg": "8a08",
	"./forward-item-1.svg": "ff5d",
	"./forward-item.svg": "fa72",
	"./forward-square.svg": "f127",
	"./forward.svg": "bdb1",
	"./frame-1.svg": "e558",
	"./frame-2.svg": "422b",
	"./frame-3.svg": "cbab",
	"./frame-4.svg": "e258",
	"./frame-5.svg": "47a1",
	"./frame.svg": "4fcc",
	"./gallery-add.svg": "26a6",
	"./gallery-edit.svg": "3201",
	"./gallery-export.svg": "590b",
	"./gallery-favorite.svg": "5f14",
	"./gallery-import.svg": "7adf",
	"./gallery-remove.svg": "0462",
	"./gallery-slash.svg": "15c2",
	"./gallery-tick.svg": "12d5",
	"./gallery.svg": "6ec0",
	"./game.svg": "dfde",
	"./gameboy.svg": "45db",
	"./gas-station.svg": "eae8",
	"./gemini-2.svg": "215a",
	"./gemini.svg": "1457",
	"./ghost.svg": "9934",
	"./gift.svg": "fb5c",
	"./glass-1.svg": "0a4b",
	"./glass.svg": "0aed",
	"./global-edit.svg": "b9f1",
	"./global-refresh.svg": "5c99",
	"./global-search.svg": "e3f4",
	"./global.svg": "8625",
	"./gps-slash.svg": "06aa",
	"./gps.svg": "1c0e",
	"./grammerly.svg": "3ec2",
	"./graph.svg": "07ee",
	"./grid-1.svg": "2eaa",
	"./grid-2.svg": "90be",
	"./grid-3.svg": "c3bf",
	"./grid-4.svg": "cd2c",
	"./grid-5.svg": "6a33",
	"./grid-6.svg": "1bfc",
	"./grid-7.svg": "e586",
	"./grid-8.svg": "f7f3",
	"./grid-9.svg": "fb1d",
	"./grid-edit.svg": "4651",
	"./grid-eraser.svg": "a4c5",
	"./grid-lock.svg": "4a2d",
	"./group-1.svg": "0959",
	"./group-10.svg": "a82c",
	"./group-11.svg": "69aa",
	"./group-2.svg": "de53",
	"./group-3.svg": "13fe",
	"./group-4.svg": "bfa7",
	"./group-5.svg": "c92d",
	"./group-6.svg": "f553",
	"./group-7.svg": "e68d",
	"./group-8.svg": "c311",
	"./group-9.svg": "ae42",
	"./group.svg": "51a3",
	"./happyemoji.svg": "233e",
	"./hashtag-1.svg": "22f4",
	"./hashtag-down.svg": "4d2e",
	"./hashtag-up.svg": "8314",
	"./hashtag.svg": "fbd5",
	"./headphone.svg": "d83e",
	"./headphones.svg": "1f3e",
	"./health.svg": "d4c8",
	"./heart-add.svg": "2f0f",
	"./heart-circle.svg": "ffc3",
	"./heart-edit.svg": "6120",
	"./heart-remove.svg": "2122",
	"./heart-search.svg": "c7e9",
	"./heart-slash.svg": "fd9c",
	"./heart-tick.svg": "f461",
	"./heart.svg": "7d16",
	"./hierarchy-2.svg": "a1e4",
	"./hierarchy-3.svg": "55cf",
	"./hierarchy-square-2.svg": "ac19",
	"./hierarchy-square-3.svg": "3a56",
	"./hierarchy-square.svg": "36f9",
	"./hierarchy.svg": "3520",
	"./home-2.svg": "3b243",
	"./home-hashtag.svg": "88b0",
	"./home-trend-down.svg": "ce65",
	"./home-trend-up.svg": "861c",
	"./home-wifi.svg": "cb61",
	"./home.svg": "ac9d",
	"./hospital.svg": "f120",
	"./house-2.svg": "07b9",
	"./house.svg": "750c",
	"./image.svg": "931c",
	"./import-1.svg": "72e3",
	"./import-2.svg": "480b",
	"./import.svg": "5d78",
	"./info-circle.svg": "6668",
	"./information.svg": "e923",
	"./instagram.svg": "bd6c",
	"./judge.svg": "3b4d",
	"./kanban.svg": "461c",
	"./key-square.svg": "e2f0",
	"./key.svg": "daf4",
	"./keyboard-open.svg": "b8eb",
	"./keyboard.svg": "649e",
	"./lamp-1.svg": "5b81",
	"./lamp-charge.svg": "ef8f",
	"./lamp-on.svg": "1430",
	"./lamp-slash.svg": "6627",
	"./lamp.svg": "9e14",
	"./language-circle.svg": "b09d",
	"./language-square.svg": "3817",
	"./layer.svg": "a98e",
	"./level.svg": "ef05",
	"./lifebuoy.svg": "9c85",
	"./like-1.svg": "26f6",
	"./like-dislike.svg": "5fc5",
	"./like-shapes.svg": "8717",
	"./like-tag.svg": "fd41",
	"./like.svg": "6d8b",
	"./link-1.svg": "60ec",
	"./link-2.svg": "aaa2",
	"./link-21.svg": "052e",
	"./link-circle.svg": "7af2",
	"./link-square.svg": "6880",
	"./link.svg": "40a1",
	"./location-add.svg": "5949",
	"./location-cross.svg": "f3af",
	"./location-minus.svg": "1bfc2",
	"./location-slash.svg": "f2f6",
	"./location-tick.svg": "000d",
	"./location.svg": "d2eb",
	"./lock-1.svg": "b1be",
	"./lock-circle.svg": "c32e",
	"./lock-slash.svg": "3708",
	"./lock.svg": "9619",
	"./login-1.svg": "d61e",
	"./login.svg": "ca2f",
	"./logout-1.svg": "129a",
	"./logout.svg": "69e3",
	"./lovely.svg": "2b05",
	"./magic-star.svg": "6a55",
	"./magicpen.svg": "742a",
	"./main-component-1.svg": "3d54",
	"./main-component.svg": "9157",
	"./man.svg": "407f",
	"./map-1.svg": "d80a",
	"./map.svg": "0443",
	"./mask-1.svg": "7932",
	"./mask-2.svg": "4418",
	"./mask-3.svg": "9329",
	"./mask.svg": "5080",
	"./math.svg": "2d5d",
	"./maximize-1.svg": "7e47",
	"./maximize-2.svg": "3d18",
	"./maximize-21.svg": "96c4",
	"./maximize-3.svg": "6439",
	"./maximize-4.svg": "7193",
	"./maximize-circle.svg": "bb0b",
	"./maximize.svg": "f098",
	"./medal-star.svg": "3604",
	"./medal.svg": "81c3",
	"./menu-1.svg": "ace0",
	"./menu-board.svg": "4a19",
	"./menu.svg": "d17f",
	"./message-2.svg": "e9c2",
	"./message-add-1.svg": "46f9",
	"./message-add.svg": "cbe8",
	"./message-circle.svg": "6c61",
	"./message-edit.svg": "1fee",
	"./message-favorite.svg": "b565",
	"./message-minus.svg": "17b2",
	"./message-notif.svg": "62c3",
	"./message-programming.svg": "375b",
	"./message-question.svg": "597e",
	"./message-remove.svg": "7a29",
	"./message-search.svg": "d9fb",
	"./message-square.svg": "3a6e",
	"./message-text-1.svg": "c498",
	"./message-text.svg": "2fbc",
	"./message-tick.svg": "00b6",
	"./message-time.svg": "c766",
	"./message.svg": "612e",
	"./messages-1.svg": "1a81",
	"./messages-2.svg": "65c8",
	"./messages-3.svg": "eb46",
	"./messages.svg": "99c1",
	"./microphone-2.svg": "50cf",
	"./microphone-slash-1.svg": "feeb",
	"./microphone-slash.svg": "b702",
	"./microphone.svg": "4eb8",
	"./microscope.svg": "cb56",
	"./milk.svg": "db9c",
	"./mini-music-sqaure.svg": "1818",
	"./minus-cirlce.svg": "42a8",
	"./minus-square.svg": "63a0",
	"./minus.svg": "3e24",
	"./mirror.svg": "dce8",
	"./mirroring-screen.svg": "ad99",
	"./mobile-programming.svg": "7c59",
	"./mobile.svg": "0df4",
	"./money-2.svg": "a37f",
	"./money-3.svg": "7371",
	"./money-4.svg": "9f84",
	"./money-add.svg": "b337",
	"./money-change.svg": "519e",
	"./money-forbidden.svg": "d352",
	"./money-recive.svg": "a47b",
	"./money-remove.svg": "0a6e",
	"./money-send.svg": "b0e0",
	"./money-tick.svg": "797a",
	"./money-time.svg": "fb7d",
	"./money.svg": "cf44",
	"./moneys.svg": "39ae",
	"./monitor-mobbile.svg": "efe2",
	"./monitor-recorder.svg": "38ca",
	"./monitor.svg": "2477",
	"./moon.svg": "0190",
	"./more-2.svg": "ae26",
	"./more-circle.svg": "901a",
	"./more-square.svg": "c5f0",
	"./more.svg": "0f4c",
	"./mouse-1.svg": "a13d",
	"./mouse-circle.svg": "74f7",
	"./mouse-square.svg": "c768",
	"./mouse.svg": "5055",
	"./music-circle.svg": "17d0",
	"./music-dashboard.svg": "18db",
	"./music-filter.svg": "c571",
	"./music-library-2.svg": "af63",
	"./music-play.svg": "cf11",
	"./music-playlist.svg": "eaa4",
	"./music-square-add.svg": "d64a",
	"./music-square-remove.svg": "37ed",
	"./music-square-search.svg": "9144",
	"./music-square.svg": "bbb9",
	"./music.svg": "65ad",
	"./musicnote.svg": "f718",
	"./next.svg": "0043",
	"./note-1.svg": "6bf7",
	"./note-2.svg": "b5cd",
	"./note-21.svg": "9dea",
	"./note-add.svg": "f2d2",
	"./note-favorite.svg": "bbae",
	"./note-remove.svg": "0733",
	"./note-square.svg": "4f77",
	"./note-text.svg": "a556",
	"./note.svg": "f079",
	"./notification-1.svg": "fd87",
	"./notification-bing.svg": "bd1e",
	"./notification-circle.svg": "e7f2",
	"./notification-favorite.svg": "6486",
	"./notification-status.svg": "d784",
	"./notification.svg": "768d",
	"./omega-circle-1.svg": "d9b3",
	"./omega-circle.svg": "95ec",
	"./omega-square-1.svg": "622f",
	"./omega-square.svg": "33ab",
	"./paintbucket.svg": "2ce3",
	"./paperclip-2.svg": "4230",
	"./paperclip.svg": "b308",
	"./password-check.svg": "838a",
	"./path-2.svg": "b994",
	"./path-square.svg": "ebc5",
	"./path.svg": "1c29",
	"./pause-circle.svg": "40a9",
	"./pause.svg": "644b",
	"./pen-add-1.svg": "5637",
	"./pen-add.svg": "d47c",
	"./pen-close-1.svg": "fea4",
	"./pen-close.svg": "e7e3",
	"./pen-remove-1.svg": "eded",
	"./pen-remove.svg": "ca82",
	"./pen-tool-1.svg": "ba79",
	"./pen-tool-2-1.svg": "1a0d",
	"./pen-tool-2.svg": "e74f",
	"./pen-tool.svg": "3965",
	"./people.svg": "1a5b",
	"./percentage-square.svg": "32a1",
	"./personalcard.svg": "d910",
	"./pet.svg": "ea5a",
	"./pharagraphspacing.svg": "a105",
	"./phone.svg": "c3bb",
	"./picture-frame.svg": "ea59",
	"./play-add.svg": "e3c3",
	"./play-circle.svg": "1708",
	"./play-cricle.svg": "e473",
	"./play-remove.svg": "4810",
	"./play.svg": "dab1",
	"./presention-chart.svg": "89e4",
	"./previous.svg": "01ed",
	"./printer-slash.svg": "4ec0",
	"./printer.svg": "345d",
	"./profile-2user.svg": "bb93",
	"./profile-add.svg": "2b1a",
	"./profile-circle.svg": "1b3e",
	"./profile-delete.svg": "c0da",
	"./profile-remove.svg": "97a6",
	"./profile-tick.svg": "2adc",
	"./profile.svg": "95dc",
	"./programming-arrow.svg": "52da",
	"./programming-arrows.svg": "409c",
	"./quote-down-circle.svg": "7e19",
	"./quote-down-square.svg": "beb3",
	"./quote-down.svg": "c91c",
	"./quote-up-circle.svg": "6ba2",
	"./quote-up-square.svg": "1e32",
	"./quote-up.svg": "6c95",
	"./radar-1.svg": "768c",
	"./radar-2.svg": "3035",
	"./radar.svg": "455e",
	"./radio.svg": "c473",
	"./ram-2.svg": "46c7",
	"./ram.svg": "d5ea",
	"./ranking-1.svg": "c6f2",
	"./ranking.svg": "2b4a",
	"./receipt-1.svg": "e6eb",
	"./receipt-2-1.svg": "3394",
	"./receipt-2.svg": "9dbf",
	"./receipt-add.svg": "77d8",
	"./receipt-discount.svg": "2d88",
	"./receipt-disscount.svg": "81f6",
	"./receipt-edit.svg": "45ef",
	"./receipt-item.svg": "9fbb",
	"./receipt-minus.svg": "43c7",
	"./receipt-search.svg": "7419",
	"./receipt-square.svg": "fa82",
	"./receipt-text.svg": "58e8",
	"./receipt.svg": "a5d7",
	"./receive-square-2.svg": "4191",
	"./receive-square.svg": "2d7a",
	"./received.svg": "e743",
	"./record-circle.svg": "e0ae",
	"./record.svg": "161c",
	"./recovery-convert.svg": "7aaa",
	"./redo.svg": "63dc",
	"./refresh-2.svg": "a072",
	"./refresh-circle.svg": "e659",
	"./refresh-left-square.svg": "0fa2",
	"./refresh-right-square.svg": "eed2",
	"./refresh-square-2.svg": "a01d",
	"./refresh.svg": "53fa",
	"./repeat-circle.svg": "4a47",
	"./repeat.svg": "c015",
	"./repeate-music.svg": "f187",
	"./repeate-one.svg": "bdd0",
	"./reserve.svg": "9f8f",
	"./rotate-left-1.svg": "0728",
	"./rotate-left.svg": "18aa",
	"./rotate-right-1.svg": "f43b",
	"./rotate-right.svg": "a212",
	"./route-square.svg": "47ef",
	"./routing-2.svg": "bd23",
	"./routing.svg": "874c",
	"./row-horizontal.svg": "51a31",
	"./row-vertical.svg": "eaec",
	"./ruler&pen.svg": "aeed",
	"./ruler.svg": "5422",
	"./safe-home.svg": "f84c",
	"./sagittarius.svg": "03e1",
	"./save-2.svg": "9247",
	"./save-add.svg": "0262",
	"./save-minus.svg": "e3af",
	"./save-remove.svg": "1a6b",
	"./scan-barcode.svg": "e670",
	"./scan.svg": "a4c53",
	"./scanner.svg": "1bba",
	"./scanning.svg": "8f15",
	"./scissor-1.svg": "3638",
	"./scissor-2.svg": "1bf3",
	"./scissor.svg": "8468",
	"./screenmirroring.svg": "3c19",
	"./scroll.svg": "5dd7",
	"./search-favorite-1.svg": "3b20",
	"./search-favorite.svg": "4322",
	"./search-normal-1.svg": "8061",
	"./search-normal.svg": "0576",
	"./search-status-1.svg": "a295",
	"./search-status.svg": "f205",
	"./search-zoom-in-1.svg": "50b9",
	"./search-zoom-in.svg": "7afa",
	"./search-zoom-out-1.svg": "77d7",
	"./search-zoom-out.svg": "4592",
	"./security-card.svg": "2ebe",
	"./security-safe.svg": "2af8",
	"./security-time.svg": "6a0e",
	"./security-user.svg": "6f47",
	"./security.svg": "5f0d",
	"./send-1.svg": "3030",
	"./send-2.svg": "c759",
	"./send-sqaure-2.svg": "5c5f",
	"./send-square.svg": "9052",
	"./send.svg": "5b6e",
	"./setting-2.svg": "35e4",
	"./setting-3.svg": "72c3",
	"./setting-4.svg": "8fc0",
	"./setting-5.svg": "415d",
	"./setting.svg": "5de8",
	"./settings.svg": "9174",
	"./shapes-1.svg": "385e",
	"./shapes-2.svg": "08db",
	"./shapes.svg": "6b03",
	"./share.svg": "bd5b",
	"./shield-cross.svg": "6ee2",
	"./shield-search.svg": "fb9e",
	"./shield-security.svg": "0276",
	"./shield-slash.svg": "b3f0",
	"./shield-tick.svg": "189e",
	"./shield.svg": "64fe",
	"./ship.svg": "03de",
	"./shop-add.svg": "a863",
	"./shop-remove.svg": "6aee",
	"./shop.svg": "5747",
	"./shopping-bag.svg": "38f3",
	"./shopping-cart.svg": "b15e",
	"./sidebar-bottom.svg": "4b29",
	"./sidebar-left.svg": "918b",
	"./sidebar-right.svg": "fbb1",
	"./sidebar-top.svg": "3902",
	"./signpost.svg": "0d2a",
	"./simcard-1.svg": "949d",
	"./simcard-2.svg": "c908",
	"./simcard.svg": "8459",
	"./size.svg": "b18f",
	"./slash.svg": "7ca8",
	"./slider-horizontal-1.svg": "894c",
	"./slider-horizontal.svg": "6336",
	"./slider-vertical-1.svg": "8e71",
	"./slider-vertical.svg": "d40d",
	"./slider.svg": "df4b",
	"./smallcaps.svg": "a94f",
	"./smart-car.svg": "35a4",
	"./smart-home.svg": "18e7",
	"./smileys.svg": "5b4a",
	"./sms-edit.svg": "c5b6",
	"./sms-notification.svg": "7493",
	"./sms-search.svg": "5eff",
	"./sms-star.svg": "9bfe",
	"./sms-tracking.svg": "bc71",
	"./sms.svg": "0a91",
	"./sort.svg": "f931",
	"./sound.svg": "e245",
	"./speaker.svg": "5989",
	"./speedometer.svg": "71c6",
	"./star-1.svg": "97c8",
	"./star-slash.svg": "b875",
	"./star.svg": "cc90",
	"./status-up.svg": "455c",
	"./status.svg": "c10e",
	"./sticker.svg": "8087",
	"./stickynote.svg": "f38c",
	"./stop-circle.svg": "b448",
	"./stop.svg": "56b4",
	"./story.svg": "2754",
	"./strongbox-2.svg": "a5b7",
	"./strongbox.svg": "717f",
	"./subtitle.svg": "7541",
	"./sun-1.svg": "5344",
	"./sun-fog.svg": "4134",
	"./sun.svg": "3961",
	"./tag-2.svg": "e2ff",
	"./tag-cross.svg": "0b89",
	"./tag-right.svg": "63d5",
	"./tag-user.svg": "c539",
	"./tag.svg": "81fd",
	"./task-square.svg": "1238",
	"./task.svg": "cee8",
	"./teacher.svg": "6de4",
	"./text-block.svg": "932f",
	"./text-bold.svg": "0e9a",
	"./text-italic.svg": "9cd5",
	"./text-underline.svg": "1a63",
	"./text.svg": "d36f",
	"./textalign-center.svg": "ae94",
	"./textalign-justifycenter.svg": "5a91",
	"./textalign-justifyleft.svg": "622b",
	"./textalign-justifyright.svg": "1045",
	"./textalign-left.svg": "1584",
	"./textalign-right.svg": "b0fa",
	"./tick-circle.svg": "c821",
	"./tick-square.svg": "0e60",
	"./ticket-2.svg": "e9d5",
	"./ticket-discount.svg": "1d2c",
	"./ticket-expired.svg": "2e7d",
	"./ticket-star.svg": "b718",
	"./ticket.svg": "6ab5",
	"./timer-1.svg": "b378",
	"./timer-pause.svg": "23e69",
	"./timer-start.svg": "e60e",
	"./timer.svg": "291e",
	"./toggle-off-circle.svg": "894b",
	"./toggle-off.svg": "277d",
	"./toggle-on-circle.svg": "5b38",
	"./toggle-on.svg": "faf7",
	"./trade.svg": "0360",
	"./transaction-minus.svg": "be22",
	"./translate.svg": "fac3",
	"./trash.svg": "af22",
	"./tree.svg": "0ff9",
	"./trend-down.svg": "8a44",
	"./trend-up.svg": "06e45",
	"./triangle.svg": "a8fe",
	"./truck-remove.svg": "0ed4",
	"./truck-tick.svg": "be14",
	"./truck-time.svg": "e04f",
	"./trush-square.svg": "3ff7",
	"./undo.svg": "34b1",
	"./unlimited.svg": "16a6",
	"./unlock.svg": "d901",
	"./user-add.svg": "2792",
	"./user-cirlce-add.svg": "44fd",
	"./user-edit.svg": "9870",
	"./user-minus.svg": "1f00",
	"./user-octagon.svg": "4a24",
	"./user-remove.svg": "43a8",
	"./user-search.svg": "065c",
	"./user-square.svg": "6c66",
	"./user-tag.svg": "84d5",
	"./user-tick.svg": "9d51",
	"./user.svg": "6aed",
	"./verify.svg": "945e",
	"./video-add.svg": "c334",
	"./video-circle.svg": "a690",
	"./video-horizontal.svg": "6cbd",
	"./video-octagon.svg": "7cad",
	"./video-play.svg": "e488",
	"./video-remove.svg": "51b1",
	"./video-slash.svg": "b8bf",
	"./video-square.svg": "d62f",
	"./video-tick.svg": "6e6e",
	"./video-time.svg": "8b18",
	"./video-vertical.svg": "300a",
	"./video.svg": "512b",
	"./voice-cricle.svg": "a2a4",
	"./voice-square.svg": "f007",
	"./volume-cross.svg": "a36f",
	"./volume-high.svg": "623f",
	"./volume-low-1.svg": "9587",
	"./volume-low.svg": "a6ea",
	"./volume-mute.svg": "6a7b",
	"./volume-slash.svg": "580f",
	"./volume-up.svg": "3569",
	"./wallet-1.svg": "a2ba",
	"./wallet-2.svg": "0a25",
	"./wallet-3.svg": "135e",
	"./wallet-add-1.svg": "384e",
	"./wallet-add.svg": "7f1c",
	"./wallet-check.svg": "e26f",
	"./wallet-minus.svg": "ef3d",
	"./wallet-money.svg": "51c5",
	"./wallet-remove.svg": "7ebf",
	"./wallet-search.svg": "408d",
	"./wallet.svg": "4f4a",
	"./warning-2.svg": "c5e3",
	"./watch-status.svg": "fe38",
	"./watch.svg": "bacc",
	"./weight-1.svg": "e76c",
	"./weight.svg": "b676",
	"./wifi-square.svg": "6b59",
	"./wifi.svg": "4351",
	"./wind-2.svg": "4c18",
	"./wind.svg": "079d",
	"./woman.svg": "48dc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";